<template>
  <div class="" v-if="quote && getVersionQuote">
    <el-form :model="form" :rules="rules" ref="form">
      <TopBarTitleComponent title="Editar Cotización" :showBackIcon="true">
        <template slot="right-area">
          <div class="d-flex justify-content-end align-items-center">
            <ButtonDeleteComponent
              class="mr-2"
              @onConfirmDelete="onConfirmDelete"
            />
            <ButtonPrimaryComponent
              title="Guardar"
              @onSaveClick="handleSaveClick"
            />
          </div>
        </template>
      </TopBarTitleComponent>
      <b-container fluid class="pb-4 px-lg-4 pt-4">
        <b-row>
          <b-col>
            <div class="card box-shadow">
              <div class="card-body">
                <b-row>
                  <b-col xs="12" sm="12" md="12">
                    <el-form-item prop="name" class="mb-4">
                      <el-input
                        placeholder="Nombre de tu cotización"
                        v-model="form.name"
                        autocomplete="none"
                        id="input-text-top-bar"
                        class="h2 font-semi-bold"
                      ></el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item prop="user_business_client_id">
                      <SelectBusinessComponent
                        @onChangeSelect="onChangeSelectBusiness"
                        :setUserBusinessClientId="form.user_business_client_id"
                      />
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <el-form-item prop="user_business_client_contact_id">
                      <slot name="label">
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <label class="font-semi-bold m-0">Nombre</label>
                          <LinkPlus
                            onlyIcon
                            @onClick="onAddBusinnesClientContact"
                            v-if="form.user_business_client_id"
                          />
                        </div>
                      </slot>
                      <el-select
                        filterable
                        v-model="form.user_business_client_contact_id"
                        placeholder="Seleccionar"
                      >
                        <el-option
                          v-for="contact in client_contacts"
                          :key="contact.id"
                          :label="contact.name"
                          :value="contact.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <InputDatePickerComponent
                      @onChangeDatePicker="
                        date => onChangeDatePicker(date, 'date_at')
                      "
                      prop="date_at"
                      placeholder=""
                      title="Fecha de emisión"
                      :setDate="form.date_at"
                    />
                  </b-col>
                  <b-col xs="12" sm="12" md="3">
                    <InputDatePickerComponent
                      @onChangeDatePicker="
                        date => onChangeDatePicker(date, 'validate_at')
                      "
                      prop="validate_at"
                      placeholder=""
                      title="Validez Cotización"
                      :setDate="form.validate_at"
                    />
                  </b-col>
                  <!-- <b-col xs="12" sm="12" md="6">
                    <b-row>
                      <b-col xs="12" sm="12" md="6">
                        <el-form-item prop="user_business_client_id">
                          <SelectBusinessComponent
                            @onChangeSelect="onChangeSelectBusiness"
                            :setUserBusinessClientId="
                              form.user_business_client_id
                            "
                          />
                        </el-form-item>
                      </b-col>
                      <b-col xs="12" sm="12" md="6">
                        <el-form-item prop="user_business_client_contact_id">
                          <slot name="label">
                            <label class="font-semi-bold m-0">Nombre</label>
                          </slot>
                          <el-select
                            filterable
                            v-model="form.user_business_client_contact_id"
                            placeholder="Seleccionar"
                          >
                            <el-option
                              v-for="contact in client_contacts"
                              :key="contact.id"
                              :label="contact.name"
                              :value="contact.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xs="12" sm="12" md="6">
                        <InputDatePickerComponent
                          @onChangeDatePicker="
                            date => onChangeDatePicker(date, 'date_at')
                          "
                          prop="date_at"
                          placeholder=""
                          title="Fecha de emisión"
                          :setDate="form.date_at"
                        />
                      </b-col>
                      <b-col xs="12" sm="12" md="6">
                        <InputDatePickerComponent
                          @onChangeDatePicker="
                            date => onChangeDatePicker(date, 'validate_at')
                          "
                          prop="validate_at"
                          placeholder=""
                          title="Validez Cotización"
                          :setDate="form.validate_at"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col xs="12" sm="12" md="6">
                    <el-form-item prop="city_id">
                      <slot name="label">
                        <label class="font-semi-bold m-0">Ciudad</label>
                      </slot>
                      <el-select
                        filterable
                        v-model="form.city_id"
                        placeholder="Seleccionar"
                      >
                        <el-option
                          v-for="city in cities"
                          :key="city.id"
                          :label="city.name"
                          :value="city.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </b-col> -->
                </b-row>
                <TableInputProducts
                  @onToogleProducts="onToogleProducts"
                  :setProducts="form.products"
                  :hideTotal="form.hide_total"
                />
                <section class="aditional-quotes mt-4">
                  <b-row>
                    <b-col xs="12" sm="12" md="6" class="order-2 order-md-1">
                      <el-form-item prop="additional_specifications">
                        <slot name="label">
                          <label class="font-semi-bold m-0"
                            >Especificaciones adicionales</label
                          >
                        </slot>

                        <ButtonPlusComponent
                          @onButtonPlusClick="
                            handleSaveAdditionalSpecifications
                          "
                        />

                        <b-row
                          class="my-4"
                          v-for="(specification,
                          index) in form.additional_specifications"
                          :key="index"
                        >
                          <b-col xs="10" sm="11" md="11">
                            <el-form-item
                              :prop="'additional_specifications.' + index"
                              :rules.sync="
                                getSyncRules && getSyncRules.rules.required()
                              "
                            >
                              <el-input
                                v-model="form.additional_specifications[index]"
                                type="text"
                                placeholder="Escriba el detalle"
                              ></el-input>
                            </el-form-item>
                          </b-col>
                          <b-col xs="2" sm="1" md="1">
                            <ButtonIcoComponent
                              class="float-right"
                              @onClick="removeAdditionalSpecifications(index)"
                            />
                          </b-col>
                        </b-row>
                      </el-form-item>

                      <div class="payment-conditions-card">
                        <div class="payment-section-header">
                          <i class="el-icon-wallet"></i>
                          <span>Condiciones de pago</span>
                        </div>

                        <el-radio-group
                          v-model="form.method_payment"
                          class="payment-radio-group"
                          @change="onMethodPaymentChange"
                        >
                          <el-radio-button :label="1"
                            >De contado</el-radio-button
                          >
                          <el-radio-button :label="2">Crédito</el-radio-button>
                          <el-radio-button :label="3" :disabled="form.hide_total"
                            >Anticipo</el-radio-button
                          >
                        </el-radio-group>
                        <p
                          v-if="form.hide_total"
                          class="m-0 mt-2 text-muted hide-total-payment-hint"
                        >
                          El modo sin total (+IVA) no admite anticipo ni cuotas.
                        </p>

                        <transition name="slide-fade">
                          <div
                            v-if="form.method_payment === 1"
                            class="panel-contado"
                            key="contado"
                          >
                            <i class="el-icon-success"></i>
                            Pago inmediato al aprobar la cotización.
                          </div>
                        </transition>

                        <transition name="slide-fade">
                          <div
                            v-if="form.method_payment === 2"
                            class="panel-credito"
                            key="credito"
                          >
                            <b-row>
                              <b-col xs="12" sm="6" md="6">
                                <label class="field-label"
                                  >Plazo de crédito</label
                                >
                                <el-select
                                  v-model="form.limit_credit"
                                  placeholder="Seleccionar plazo"
                                  size="small"
                                >
                                  <el-option
                                    v-for="(limit, index) in limitCredits"
                                    :key="index"
                                    :label="limit.label"
                                    :value="limit.value"
                                  ></el-option>
                                </el-select>
                              </b-col>
                              <b-col xs="12" sm="6" md="6">
                                <InputDatePickerComponent
                                  @onChangeDatePicker="
                                    date =>
                                      onChangeDatePicker(
                                        date,
                                        'limit_credit_at'
                                      )
                                  "
                                  prop="limit_credit_at"
                                  placeholder=""
                                  title="Fecha de vencimiento"
                                  :setDate="form.limit_credit_at"
                                  v-if="form.limit_credit === 'others'"
                                />
                              </b-col>
                            </b-row>
                          </div>
                        </transition>

                        <transition name="slide-fade">
                          <div
                            v-if="form.method_payment === 3"
                            class="panel-anticipo"
                            key="anticipo"
                          >
                            <label class="field-label">Observaciones</label>
                            <el-input
                              v-model="form.observation_advance"
                              type="textarea"
                              :rows="2"
                              placeholder="Ej: 60% al inicio, 40% contra entrega del proyecto..."
                              size="small"
                            ></el-input>

                            <!-- Cuotas de pago -->
                            <div class="installments-section mt-3">
                              <div class="installments-header">
                                <span class="field-label m-0">
                                  <i class="el-icon-s-grid"></i> Cuotas de pago
                                </span>
                                <span
                                  :class="
                                    totalPercentage === 100
                                      ? 'pct-ok'
                                      : 'pct-warn'
                                  "
                                  class="pct-badge"
                                >
                                  {{ totalPercentage }}%
                                </span>
                              </div>

                              <div class="quick-tpl">
                                <button
                                  type="button"
                                  v-for="tpl in quickTemplates"
                                  :key="tpl.key"
                                  :class="[
                                    'tpl-btn',
                                    { active: activeTpl === tpl.key }
                                  ]"
                                  @click="applyInstallmentTemplate(tpl.key)"
                                >
                                  {{ tpl.label }}
                                </button>
                                <button
                                  type="button"
                                  class="tpl-btn tpl-custom"
                                  @click="addInstallment"
                                >
                                  <i class="el-icon-plus"></i> Personalizar
                                </button>
                              </div>

                              <div
                                v-for="(inst, index) in installments"
                                :key="'inst-' + index"
                                class="inst-row"
                              >
                                <div class="inst-row-main">
                                  <div class="inst-field inst-label">
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      v-model="installments[index].label"
                                      :placeholder="getInstallmentLabel(index)"
                                    />
                                  </div>
                                  <div class="inst-field inst-pct">
                                    <div class="pct-input-wrap">
                                      <input
                                        type="number"
                                        class="form-control form-control-sm"
                                        v-model.number="
                                          installments[index].percentage
                                        "
                                        min="1"
                                        max="100"
                                        @input="recalcInstallmentAmounts"
                                      />
                                      <span class="pct-symbol">%</span>
                                    </div>
                                  </div>
                                  <div class="inst-field inst-amount">
                                    <span class="amount-display">
                                      ${{ Number(inst.amount || 0).toFixed(2) }}
                                    </span>
                                  </div>
                                  <div class="inst-field inst-delete">
                                    <ButtonIcoComponent
                                      v-if="installments.length > 1"
                                      @onClick="removeInstallment(index)"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </b-col>
                    <b-col
                      xs="12"
                      sm="12"
                      md="4"
                      class="mb-3 mb-md-0 ml-md-auto order-1 order-md-2"
                    >
                      <DocumentCalculator
                        :setDisc="form.discount"
                        :setProducts="form.products"
                        :setHideTotal="form.hide_total"
                        allowTaxToggle
                        allowHideTotalToggle
                        @onChangeSwitchDiscount="onChangeSwitchDiscount"
                        @onChangeSwitchTaxt="onChangeSwitchTaxt"
                        @onChangeSwitchHideTotal="onChangeSwitchHideTotal"
                        @onTotalChange="onCalcTotalChange"
                      />
                    </b-col>
                  </b-row>
                </section>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </el-form>
    <!-- dialog to add new contact -->
    <el-dialog
      :visible.sync="dialogAddContact"
      :fullscreen="false"
      :before-close="handleCloseContactAdd"
    >
      <AddContactComponent
        :business_client_id="form.user_business_client_id"
        :showBackIcon="false"
        v-if="dialogAddContact"
        @onSuccess="onSuccessContactAdd"
      />
    </el-dialog>
  </div>
</template>

<script>
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import ButtonPlusComponent from "../../../../components/ButtonPlus";
import ButtonDeleteComponent from "../../../../components/ButtonDelete";
import ButtonIcoComponent from "../../../../components/ButtonIco";
import SelectBusinessComponent from "../../../../components/SelectBusinessV2";
import InputDatePickerComponent from "../../../../components/InputDatePicker";
import TableInputProducts from "../../../components/TableInputProducts";
import DocumentCalculator from "../../../components/DocumentCalculator";
import AddContactComponent from "../components/AddContact";

import Validate from "@/assets/validate";
import { formatDateYmd } from "@/assets/utils/format";
import CitiesServices from "@/services/CitiesServices";
import quoteService from "../services/quoteService";
import { limitCredits } from "../assets/resources";

import LinkPlus from "../../../../components/LinkPlus";

export default {
  name: "QuotesEditComponent",
  data() {
    return {
      dialogAddContact: false,
      cities: [],
      client_contacts: [],
      limitCredits,
      idVersion: null,
      quote: null,
      form: {
        name: "",
        user_business_client_id: "",
        user_business_client_contact_id: "",
        date_at: formatDateYmd(new Date()),
        validate_at: formatDateYmd(new Date()),
        city_id: "",
        discount: 0,
        discount_type: "",
        products: [],
        additional_specifications: [],
        method_payment: 1,
        limit_credit: "",
        limit_credit_at: "",
        observation_advance: "",
        isTax: true,
        hide_total: false
      },
      rules: {
        name: [Validate.rules.required()],
        user_business_client_id: [Validate.rules.required("change")],
        // user_business_client_contact_id: [Validate.rules.required("change")],
        date_at: [Validate.rules.required()],
        validate_at: [Validate.rules.required()],
        // city_id: [Validate.rules.required("change")],
        method_payment: [Validate.rules.required("change")],
        limit_credit: [Validate.rules.required("change")],
        limit_credit_at: [Validate.rules.required("change")],
        observation_advance: [Validate.rules.required()]
      },
      quickTemplates: [
        { key: "60-40", label: "60 / 40" },
        { key: "50-50", label: "50 / 50" },
        { key: "40-30-30", label: "40 / 30 / 30" }
      ],
      activeTpl: "60-40",
      installments: [
        { label: "Anticipo", percentage: 60, amount: 0, sort_order: 0 },
        { label: "Entrega final", percentage: 40, amount: 0, sort_order: 1 }
      ],
      quoteTotal: 0
    };
  },
  computed: {
    getSyncRules() {
      return Validate;
    },
    getVersionQuote() {
      return this.quote.versions.find(v => this.idVersion === v.id);
    },
    totalPercentage() {
      return this.installments.reduce(
        (sum, i) => sum + (Number(i.percentage) || 0),
        0
      );
    }
  },
  methods: {
    // ─── Installment methods ───
    applyInstallmentTemplate(key) {
      this.activeTpl = key;
      const templates = {
        "60-40": [
          { l: "Anticipo", p: 60 },
          { l: "Entrega final", p: 40 }
        ],
        "50-50": [
          { l: "Primera cuota", p: 50 },
          { l: "Segunda cuota", p: 50 }
        ],
        "40-30-30": [
          { l: "Anticipo", p: 40 },
          { l: "Segunda cuota", p: 30 },
          { l: "Entrega final", p: 30 }
        ]
      };
      const tpl = templates[key] || templates["60-40"];
      this.installments = tpl.map((item, i) => ({
        label: item.l,
        percentage: item.p,
        amount: +(this.quoteTotal * (item.p / 100)).toFixed(2),
        sort_order: i
      }));
    },
    addInstallment() {
      this.activeTpl = "";
      this.installments.push({
        label: "",
        percentage: 0,
        amount: 0,
        sort_order: this.installments.length
      });
    },
    removeInstallment(index) {
      this.activeTpl = "";
      this.installments.splice(index, 1);
      this.installments.forEach((inst, i) => (inst.sort_order = i));
      this.recalcInstallmentAmounts();
    },
    recalcInstallmentAmounts() {
      this.installments.forEach(inst => {
        inst.amount = +(
          this.quoteTotal *
          ((inst.percentage || 0) / 100)
        ).toFixed(2);
      });
    },
    getInstallmentLabel(index) {
      return (
        ["Anticipo", "Segunda cuota", "Tercera cuota", "Cuota final"][index] ||
        "Cuota " + (index + 1)
      );
    },
    onMethodPaymentChange(newMethod) {
      if (newMethod !== 3) {
        this.form.observation_advance = "";
        this.installments = [
          { label: "Anticipo", percentage: 60, amount: 0, sort_order: 0 },
          { label: "Entrega final", percentage: 40, amount: 0, sort_order: 1 }
        ];
        this.activeTpl = "60-40";
      }
      if (newMethod !== 2) {
        this.form.limit_credit = "";
        this.form.limit_credit_at = "";
      }
    },
    onChangeSwitchTaxt({ value }) {
      this.form.isTax = value;
    },
    onChangeSwitchHideTotal({ value }) {
      this.form.hide_total = !!value;
      if (this.form.hide_total) {
        this.form.discount = 0;
        if (this.form.method_payment === 3) {
          this.form.method_payment = 1;
          this.$notifications.warning({
            message:
              "El modo sin total (+IVA) no admite anticipo ni cuotas. La forma de pago cambió a De contado."
          });
        }
      }
    },
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    handleSaveAdditionalSpecifications() {
      this.form.additional_specifications.push("");
    },
    removeAdditionalSpecifications(index) {
      this.form.additional_specifications.splice(index, 1);
    },
    onToogleProducts({ products }) {
      this.form.products = [...products];
    },
    onChangeDatePicker({ date }, property) {
      this.form[property] = date;
    },
    onChangeSelectBusiness({ client }) {
      const { id, contacts } = client;
      this.form.user_business_client_contact_id = null;
      this.form.user_business_client_id = id;
      this.client_contacts = contacts;
    },
    onCalcTotalChange(total) {
      this.quoteTotal = total;
      this.recalcInstallmentAmounts();
    },
    onChangeSwitchDiscount({ discount, type }) {
      this.form.discount = discount;
      this.form.discount_type = type;
    },
    /* dialog to add conctact */
    onSuccessContactAdd({ contact }) {
      this.client_contacts = [contact, ...this.client_contacts];
      this.form.user_business_client_contact_id = contact.id;
      this.dialogAddContact = false;
    },
    onAddBusinnesClientContact() {
      this.dialogAddContact = true;
    },
    handleCloseContactAdd() {
      this.dialogAddContact = false;
    },
    onValidateFormProducts() {
      return this.form.products.length >= 1 ? true : false;
    },
    handleSaveClick() {
      if (!this.onValidateFormProducts()) {
        const message = "Debe agregar productos a la cotización.";
        this.$notifications.error({ message });
        return;
      }
      if (this.form.hide_total && this.form.method_payment === 3) {
        this.$notifications.error({
          message:
            "El modo sin total (+IVA) no admite anticipo ni cuotas. Cambia la forma de pago o desactiva el modo."
        });
        return;
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.$store.dispatch("toggleRequestLoading");
          try {
            const payload = { ...this.form };
            if (this.form.method_payment !== 3) {
              payload.observation_advance = "";
            }
            if (this.form.method_payment === 3 && this.installments.length) {
              this.recalcInstallmentAmounts();
              var lines = [];
              if (this.form.observation_advance) {
                lines.push(this.form.observation_advance);
                lines.push("");
              }
              lines.push("Detalle de cuotas:");
              this.installments.forEach(function(inst) {
                lines.push(
                  "- " +
                    inst.label +
                    ": " +
                    inst.percentage +
                    "% — $" +
                    inst.amount.toFixed(2)
                );
              });
              payload.observation_advance = lines.join("\n");
            }
            let response = await quoteService
              .updateQuoteId(this.quote.id, payload)
              .finally(() => {
                this.$store.dispatch("toggleRequestLoading");
              });
            if (response && response.data && response.data.success) {
              // ID de la versión resultante: el backend crea una nueva versión cuando
              // cambian productos (precios, cantidades, altas). Preferir la versión
              // nueva del response sobre la local (que apunta a la versión vieja).
              const newVersionId =
                response.data.data &&
                response.data.data.user_business_quote_v_id
                  ? response.data.data.user_business_quote_v_id
                  : this.idVersion;

              // Sync installments — actualiza o limpia según la forma de pago
              if (newVersionId) {
                try {
                  if (
                    this.form.method_payment === 3 &&
                    this.installments.length
                  ) {
                    await quoteService.syncInstallments(
                      this.quote.id,
                      newVersionId,
                      this.installments.map((inst, i) => ({
                        label: inst.label,
                        percentage: inst.percentage,
                        sort_order: i
                      }))
                    );
                  } else {
                    // Elimina cuotas huérfanas si ya no es forma de pago anticipo
                    await quoteService.syncInstallments(
                      this.quote.id,
                      newVersionId,
                      []
                    );
                  }
                } catch (e) {
                  /* tabla puede no existir aún */
                }
              }

              this.$router
                .push({
                  name: "sales.quotes.view",
                  params: {
                    id: this.quote.id,
                    idVersion: newVersionId
                  }
                })
                .catch(() => {});
            } else if (response && response.data && !response.data.success) {
              this.$notifications.error({
                message:
                  response.data.message || "No se pudo actualizar la cotización"
              });
            }
          } catch (error) {
            return false;
          }
        }
      });
    },
    async onConfirmDelete() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await quoteService
          .deleteQuoteId(this.quote.id)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        if (response.data.success) {
          this.goRouter("sales.documents");
        }
      } catch (error) {
        return false;
      }
    },
    handleResetFormInput(input) {
      this.form[input] = "";
    },
    handleDataForm() {
      const { city_id } = this.quote;
      const { id: user_business_client_id } = this.quote.client;

      const contact = this.quote.contact;

      if (contact) {
        const { id: user_business_client_contact_id } = contact;

        this.form = {
          ...this.form,
          ...{
            user_business_client_contact_id
          }
        };
      }

      const {
        name,
        date_at,
        validate_at,
        discount,
        additional_specifications,
        method_payment,
        limit_credit,
        limit_credit_at,
        observation_advance,
        hide_total,
        products
      } = this.getVersionQuote;

      //this.client_contacts = contact && [contact];
      this.client_contacts = this.quote.client.contacts;

      const methodPaymentInt = parseInt(method_payment) || 1;

      this.form = {
        ...this.form,
        ...{
          user_business_client_id,
          name,
          city_id,
          date_at,
          validate_at,
          discount,
          additional_specifications,
          method_payment: methodPaymentInt,
          limit_credit,
          limit_credit_at,
          observation_advance,
          hide_total: !!hide_total,
          user_business_quote_v_id: this.idVersion
        }
      };

      // Parse installments from observation_advance text if available
      if (
        observation_advance &&
        methodPaymentInt === 3 &&
        observation_advance.indexOf("Detalle de cuotas:") !== -1
      ) {
        var obsLines = observation_advance.split("\n");
        var parsedInst = [];
        var obsTextLines = [];
        var inDetailSection = false;

        for (var idx = 0; idx < obsLines.length; idx++) {
          var obsLine = obsLines[idx].trim();
          if (obsLine === "Detalle de cuotas:") {
            inDetailSection = true;
            continue;
          }
          if (inDetailSection && obsLine.indexOf("- ") === 0) {
            var instMatch = obsLine.match(/^- (.+?):\s*(\d+)%\s*—\s*\$(.+)$/);
            if (instMatch) {
              parsedInst.push({
                label: instMatch[1],
                percentage: parseInt(instMatch[2]),
                amount: parseFloat(instMatch[3]),
                sort_order: parsedInst.length
              });
            }
          } else if (!inDetailSection && obsLine) {
            obsTextLines.push(obsLine);
          }
        }

        if (parsedInst.length) {
          this.installments = parsedInst;
          this.activeTpl = "";
          this.form.observation_advance = obsTextLines.join("\n");
        }
      }

      this.handleDataFormProducts(products);
    },
    handleDataFormProducts(products) {
      products.map(product => {
        const {
          id: user_business_quote_product_id,
          product_amount,
          product_quantity,
          product_detail,
          taxes_code,
          taxes_code_percentage,
          taxes_percentage
        } = product;

        const { code, alternative_code, id, name } = product.product;

        this.form.products.push({
          user_business_quote_product_id,
          product_amount,
          product_quantity,
          name,
          code,
          original_code: code,
          alternative_code: alternative_code || null,
          id,
          product_detail,
          taxes_code,
          taxes_code_percentage,
          taxes_percentage
        });
      });
    },
    async getQuote(quoteId) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        let response = await quoteService.getQuoteId(quoteId).finally(() => {
          this.$store.dispatch("toggleRequestLoading");
        });
        if (response) {
          this.quote = response.data.quote;
          this.handleDataForm();
        }
      } catch (error) {
        return false;
      }
    },
    async getCities() {
      await CitiesServices.getCities()
        .then(response => {
          if (response.data.success) this.cities = response.data.cities;
        })
        .catch(() => {});
    }
  },
  components: {
    TopBarTitleComponent,
    ButtonPlusComponent,
    ButtonPrimaryComponent,
    ButtonDeleteComponent,
    ButtonIcoComponent,
    SelectBusinessComponent,
    InputDatePickerComponent,
    TableInputProducts,
    DocumentCalculator,
    AddContactComponent,
    LinkPlus
  },
  mounted() {
    const { id: quoteId, idVersion } = this.$route.params;
    this.idVersion = parseInt(idVersion);
    if (quoteId && idVersion) {
      this.getQuote(quoteId);
      this.getCities();
    }
  }
};
</script>

<style lang="sass">
.date-picker-quote
  .el-input__prefix
    right: 0px !important;
    left: auto;

.el-autocomplete
  width: 100% !important;
.my-autocomplete
  li
    line-height: normal;
    padding: 7px;
    .value
      text-overflow: ellipsis;
      overflow: hidden;
    .link
      font-size: 12px;
      color: #b4b4b4;

.el-icon-delete
  font-size: 1.5rem;
</style>
